import styled from '@emotion/styled';

export const Container = styled.div`
  max-width: ${({ theme }) => theme.spacing(300)};
  padding-left: ${({ theme }) => theme.spacing(5)};
  padding-right: ${({ theme }) => theme.spacing(5)};

  margin-left: auto;
  margin-right: auto;
`;

export const Overlay = styled.div`
position: fixed;
top: 0;
left: 0;
width: 100vw;
height: 100vh;
display: flex;
justify-content: center;
align-items: center;
background-color: rgba(0, 0, 0, 0.8);
z-index: 1200;
`;

export const ModalDiv = styled.div`
max-width: calc(100vw - 48px);
  max-height: calc(100vh - 24px);
`;
